import * as React from 'react';

export const NoDataMessage = () => (
    <div className="NoDataMessage">
        <h3>No results found</h3>
        <p>Nothing matches your filters or search query</p>
    </div>
);
